import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "relative flex flex-col justify-between bg-white shadow z-10" }
const _hoisted_2 = { class: "flex flex-row min-w-full justify-between" }
const _hoisted_3 = { class: "flex items-center justify-start px-5 md:border-r border-background" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "hidden lg:flex items-center justify-center" }
const _hoisted_6 = { class: "border-t-2 border-transparent" }
const _hoisted_7 = { class: "hidden lg:flex items-center justify-start px-5 border-l border-background xl:pl-64" }
const _hoisted_8 = { class: "lg:hidden flex items-center" }
const _hoisted_9 = {
  key: 0,
  class: "inline-block top-icon cursor-pointer w-6 h-6 text-gray-500",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("path", { d: "M4 6h16M4 12h16M4 18h16" }, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 1,
  class: "inline-block top-icon cursor-pointer w-6 h-6 text-gray-500",
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  "aria-labelledby": "base",
  role: "presentation"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("title", {
  id: "base",
  lang: "en"
}, "base icon", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("g", { fill: "currentColor" }, [
  /*#__PURE__*/_createElementVNode("path", { d: "M4.73077 5.8045C4.0249 5.09863 5.09865 4.02891 5.80452 4.73075L12 10.9262L18.1955 4.73075C18.9014 4.02488 19.9751 5.09863 19.2692 5.8045L13.0738 12L19.2692 18.1955C19.9751 18.9013 18.9014 19.9751 18.1955 19.2692L12 13.0737L5.80452 19.2692C5.09865 19.9751 4.02486 18.9013 4.73077 18.1955L10.9263 12L4.73077 5.8045Z" })
], -1)
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = {
  key: 0,
  class: "lg:hidden"
}
const _hoisted_17 = { class: "items-center justify-center bg-white" }
const _hoisted_18 = { class: "border-t-2 border-transparent" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "border-t border-light-1 my-1" }, null, -1)
const _hoisted_20 = { class: "flex items-center" }
const _hoisted_21 = { class: "flex text-xs text-dark-3 group-hover:text-light-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_app_icon = _resolveComponent("app-icon")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_dropdown_menu_item = _resolveComponent("dropdown-menu-item")!
  const _component_dropdown_menu_divider = _resolveComponent("dropdown-menu-divider")!
  const _component_dropdown_menu = _resolveComponent("dropdown-menu")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, { to: "/" }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              class: "inline-block md:px-3",
              src: require('@/assets/img/logo.svg'),
              alt: "Logo"
            }, null, 8, _hoisted_4)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("nav", _hoisted_5, [
        _createElementVNode("span", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.routes, (route) => {
            return (_openBlock(), _createBlock(_component_router_link, {
              key: route.name,
              to: route.to,
              class: _normalizeClass(["inline-block leading-8 py-4 px-4 mx-4 border-b-2", [
                            _ctx.isRouteActive(route.name)
                                ? 'font-medium text-dark-1 border-blue-500'
                                : 'text-dark-2 border-white hover:text-dark-1 hover:border-dark-2 hover:border-opacity-20'
                        ]])
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t(`routes.${route.name}`)), 1)
              ]),
              _: 2
            }, 1032, ["to", "class"]))
          }), 128))
        ]),
        _createVNode(_component_app_button, {
          class: "mx-4",
          onClick: _ctx.createNewMail,
          "button-size": "large"
        }, {
          left: _withCtx(() => [
            _createVNode(_component_app_icon, { name: "Plus" })
          ]),
          default: _withCtx(() => [
            _createTextVNode(" " + _toDisplayString(_ctx.$t("general.create")), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_dropdown_menu, { type: "avatar" }, {
          default: _withCtx(() => [
            _createVNode(_component_dropdown_menu_item, {
              label: _ctx.$t('components.header.accountSettings'),
              onClick: _ctx.openSettings
            }, null, 8, ["label", "onClick"]),
            _createVNode(_component_dropdown_menu_item, {
              label: _ctx.$t('components.header.support'),
              onClick: _ctx.goToSupportPage
            }, null, 8, ["label", "onClick"]),
            _createVNode(_component_dropdown_menu_divider),
            _createVNode(_component_dropdown_menu_item, {
              label: _ctx.$t('components.header.switchToClassic'),
              onClick: _ctx.switchToClassic
            }, null, 8, ["label", "onClick"]),
            _createVNode(_component_dropdown_menu_divider),
            _createVNode(_component_dropdown_menu_item, {
              label: _ctx.$t('components.header.signOut'),
              altLabel: ' ' + _ctx.me.email + '',
              onClick: _ctx.signOut
            }, null, 8, ["label", "altLabel", "onClick"])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("button", {
          class: "outline-none mobile-menu-button leading-8 py-4 px-5",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleShowMobileMenu && _ctx.toggleShowMobileMenu(...args)))
        }, [
          (!_ctx.showMobileMenu)
            ? (_openBlock(), _createElementBlock("svg", _hoisted_9, _hoisted_11))
            : (_openBlock(), _createElementBlock("svg", _hoisted_12, _hoisted_15))
        ])
      ])
    ]),
    (_ctx.showMobileMenu)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _createElementVNode("nav", _hoisted_17, [
            _createElementVNode("span", _hoisted_18, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.routes, (route) => {
                return (_openBlock(), _createBlock(_component_router_link, {
                  key: route.name,
                  to: route.to,
                  class: _normalizeClass(["block py-4 mx-4 border-b-2", [
                            _ctx.isRouteActive(route.name)
                                ? 'font-medium text-dark-1 border-blue-500'
                                : 'text-dark-2 border-white hover:text-dark-1 hover:border-dark-2 hover:border-opacity-20'
                        ]]),
                  onClick: _ctx.toggleShowMobileMenu
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t(`routes.${route.name}`)), 1)
                  ]),
                  _: 2
                }, 1032, ["to", "class", "onClick"]))
              }), 128))
            ]),
            _hoisted_19,
            _createElementVNode("span", {
              class: "block py-4 mx-4 border-b-2 text-dark-2 border-white hover:text-dark-1 hover:border-dark-2 hover:border-opacity-20",
              onClick: _cache[1] || (_cache[1] = ($event: any) => {
                        _ctx.goToSupportPage();
                        _ctx.toggleShowMobileMenu();
                    })
            }, _toDisplayString(_ctx.$t("components.header.support")), 1),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("span", {
                class: "flex py-4 mx-4 border-b-2 text-dark-2 border-white hover:text-dark-1 hover:border-dark-2 hover:border-opacity-20",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.signOut && _ctx.signOut(...args)))
              }, _toDisplayString(_ctx.$t("components.header.signOut")), 1),
              _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.me.email), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}